__turbopack_context__.v({
  "active": "AddToWishlistButton-module__5PNnfW__active",
  "blok-big-title": "AddToWishlistButton-module__5PNnfW__blok-big-title",
  "blok-subtitle": "AddToWishlistButton-module__5PNnfW__blok-subtitle",
  "blok-title": "AddToWishlistButton-module__5PNnfW__blok-title",
  "inner__button": "AddToWishlistButton-module__5PNnfW__inner__button",
  "text": "AddToWishlistButton-module__5PNnfW__text",
  "wishlistButton": "AddToWishlistButton-module__5PNnfW__wishlistButton",
});
